import React, { useEffect, useRef, useState } from "react";
import { staff, staffEdit } from "../utils/api";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL, getBrancheslist } from "../utils/api";
import axios from "axios";
import { useParams } from "react-router-dom";

const AddStaffLayer = () => {
  const [nameErr, setNameErr] = useState(false);
  const [emailErr, setEmailErr] = useState(false);
  const [passwordErr, setPasswordErr] = useState(false);
  const [phoneErr, setPhoneErr] = useState(false);
  const [branchErr, setBranchErr] = useState(false);
  const [branchList, setBranchList] = useState({});
  const [thumbnail, setThumbnail] = useState("");
 const [thumbnailErr, setThumbnailErr] = useState(false);
const [imagePreview, setImagePreview] = useState(null);
 const [userTypeErr, setUserTypeErr] = useState(false);
 
  let { id } = useParams();
  useEffect(() => {
    let branchesList = getBrancheslist();
    setBranchList(branchesList);
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    branch_name: "1",
    image: "",
    type:""
  });
  const navigate = useNavigate();


  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
     // const src = URL.createObjectURL(e.target.files[0]);
      //setImagePreview(src);
       
      var targetFile = e.target.files[0];
      console.log('targetFile', targetFile);
      console.log('targetFilename',  targetFile.name);
      let filename = targetFile.name;
   
     const src = URL.createObjectURL(targetFile);
     console.log(src);
     setThumbnailErr(false);
 
     setThumbnail(targetFile);
     setImagePreview(src);
     setFormData({ ...formData, image: targetFile });
                    
    }
  };

  const handleRemoveImage = () => {
    setImagePreview(null);
    setThumbnailErr(true);

  };





  async function fetchStaffInfo() {
    axios
      .get(process.env.REACT_APP_API_BASE_URL + "staff-details/" + id)
      .then((res) => {
        // return false;
        if (res.data) {
          console.log("red data", res.data);
  let baseurl = API_URL.replace("api", "");
  setImagePreview(baseurl + res.data.image);
       
          setFormData({
            ...formData,
            name: res.data.name,
            phone: res.data.phone,
            email: res.data.email,
            password: res.data.password,
            branch_name: res.data.branch_name,
            image :  res.data.image,
            type: res.data.type
          });
        } else {
          toast.success("something went wrong...");
        }
      })
      .catch((err) => {
        console.error(err);
        alert(err);
      });
  }

  useEffect(() => {
    if (id) {
      fetchStaffInfo();
    } else {
      setFormData({
        ...formData,
        name: "",
        phone: "",
        email: "",
        password: "",
        branch_name: "1",
        image : "",
        type:""
    
      });
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (
        formData?.name &&
        formData?.email &&
        formData?.phone &&
        formData?.password &&
        formData?.branch_name && formData?.type
      ) {

        
        if (id) {
          await staffEdit(id, formData);
        } else {
          await staff(formData);
        }
        toast.success("You have successfully Saved Staff info");
        navigate(
          "/" +
            JSON.parse(localStorage.getItem("activeUser")).user_type +
            "/staff"
        );
      } else {
        if (!formData?.name) {
          setNameErr(true);
        }
        if (!formData?.email) {
          setEmailErr(true);
        }
        if (!formData?.phone) {
          setPhoneErr(true);
        }
        if (!formData?.password) {
          setPasswordErr(true);
        }

        if (!formData?.branch_name) {
          setBranchErr(true);
        }
         if (!formData?.type) {
          setUserTypeErr(true);
        }
      }
    } catch (error) {
      toast.error("Request failed: " + error.message);
    }
  };

  return (
    <div className="row gy-4">
      <div className="col-lg-12">
        <div className="card mt-24">
          <div className="card-header border-bottom">
            <h6 className="text-xl mb-0">{id ? "Edit" : "Add New "} Staff</h6>
          </div>
          <div className="card-body p-24">
            <ToastContainer></ToastContainer>
            <form onSubmit={handleSubmit} className="d-flex flex-column gap-20">
              <div className="row"> 
                <div className="col-lg-6 " >
                  <label
                    className="form-label fw-bold text-neutral-900"
                    htmlFor="branch_name"
                  >
                    User Type:{" "}
                  </label>
                  <select
                    onChange={(e) => {
                      setFormData({ ...formData, type: e.target.value });
                      setUserTypeErr(false);
                      if (e.target.value == 0) {
                        setUserTypeErr(true);
                      }
                    }}
                    id="type"
                    name="type"
                    value={formData.type}
                    className={
                      userTypeErr
                        ? "form-control border border-red radius-8"
                        : "form-control border border-neutral-200 radius-8"
                    }
                  >
                        <option value={""}>Select User Type</option>
                        <option value={"staff"}>Staff</option>
                        <option value={"subadmin"}>Sub Admin</option>
                     
                  </select>
                  {userTypeErr && (
                    <span className="error-message">
                      {"User Type is mandatory"}
                    </span>
                  )}
                </div>


 <div className="col-lg-6 " style={{display:"none"}}>
                  <label
                    className="form-label fw-bold text-neutral-900"
                    htmlFor="branch_name"
                  >
                    Branch Name:{" "}
                  </label>
                  <select
                    onChange={(e) => {
                      setFormData({ ...formData, branch_name: e.target.value });
                      setBranchErr(false);
                      if (e.target.value == 0) {
                        setBranchErr(true);
                      }
                    }}
                    id="branch_name"
                    name="branch_name"
                    value={formData.branch_name}
                    className={
                      branchErr
                        ? "form-control border border-red radius-8"
                        : "form-control border border-neutral-200 radius-8"
                    }
                  >
                    {branchList.length > 0 &&
                      branchList.map((branchval, key) => (
                        <option value={key}>{branchval}</option>
                      ))}
                  </select>
                  {branchErr && (
                    <span className="error-message">
                      {"Branch name is mandatory"}
                    </span>
                  )}
                </div>

                <div className="col-lg-6">
                  <label
                    className="form-label fw-bold text-neutral-900"
                    htmlFor="title"
                  >
                    Name:{" "}
                  </label>
                  <input
                    type="text"
                    className={
                      nameErr
                        ? "form-control border border-red radius-8"
                        : "form-control border border-neutral-200 radius-8"
                    }
                    id="name"
                    name="name"
                    placeholder="Enter Name"
                    value={formData.name}
                    onChange={(e) => {
                      setFormData({ ...formData, name: e.target.value });
                      setNameErr(false);
                      if (e.target.value.trim() == "") {
                        setNameErr(true);
                      }
                    }}
                  />
                  {nameErr && (
                    <span className="error-message">{"Name is mandatory"}</span>
                  )}
                </div>

                <div className="col-lg-6">
                  <label
                    className="form-label fw-bold text-neutral-900"
                    htmlFor="title"
                  >
                    Phone:{" "}
                  </label>
                  <input
                    type="text"
                    className={
                      phoneErr
                        ? "form-control border border-red radius-8"
                        : "form-control border border-neutral-200 radius-8"
                    }
                    id="phone"
                    placeholder="Enter Phone"
                    name="phone"
                    value={formData.phone}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        phone: e.target.value.trim(),
                      });
                      setPhoneErr(false);
                      if (e.target.value.trim() == "") {
                        setPhoneErr(true);
                      }
                    }}
                  />
                  {phoneErr && (
                    <span className="error-message">
                      {"Phone No is mandatory"}
                    </span>
                  )}
                </div>

                <div className="col-lg-6">
                  <label
                    className="form-label fw-bold text-neutral-900"
                    htmlFor="title"
                  >
                    Email:{" "}
                  </label>
                  <input
                    type="text"
                    className={
                      emailErr
                        ? "form-control border border-red radius-8"
                        : "form-control border border-neutral-200 radius-8"
                    }
                    id="email"
                    placeholder="Enter Email"
                    name="email"
                    autoComplete="off"
                    value={formData.email}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        email: e.target.value.trim(),
                      });
                      setEmailErr(false);
                      if (e.target.value.trim() == "") {
                        setEmailErr(true);
                      }
                    }}
                  />
                  {emailErr && (
                    <span className="error-message">
                      {"Email ID is mandatory"}
                    </span>
                  )}
                </div>
                {!id ? (
                  <div className="col-lg-6">
                    <label
                      className="form-label fw-bold text-neutral-900"
                      htmlFor="title"
                    >
                      Password:{" "}
                    </label>
                    <input
                      type="password"
                      className={
                        passwordErr
                          ? "form-control border border-red radius-8"
                          : "form-control border border-neutral-200 radius-8"
                      }
                      id="password"
                      autoComplete="off"
                      name="password"
                      placeholder="Enter Password"
                      value={formData.password}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          password: e.target.value.trim(),
                        });
                        setPasswordErr(false);
                        if (e.target.value.trim() == "") {
                          setPasswordErr(true);
                        }
                      }}
                    />
                    {passwordErr && (
                      <span className="error-message">
                        {"Password is mandatory"}
                      </span>
                    )}
                  </div>
                ) : (
                  ""
                )}

                <div className="col-lg-6">
                  <label className="form-label fw-bold text-neutral-900">
                    Upload Thumbnail
                  </label>
                  <div className="upload-image-wrapper">
                    {imagePreview ? (
                      <div className="uploaded-img position-relative h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50">
                        <button
                          type="button"
                          className="uploaded-img__remove position-absolute top-0 end-0 z-1 text-2xxl line-height-1 me-8 mt-8 d-flex bg-danger-600 w-40-px h-40-px justify-content-center align-items-center rounded-circle"
                          onClick={handleRemoveImage}
                        >
                          <iconify-icon
                            icon="radix-icons:cross-2"
                            className="text-2xl text-white"
                          ></iconify-icon>
                        </button>
                        <img
                          id="uploaded-img__preview"
                          className="w-100 h-100 object-fit-cover"
                          src={imagePreview}
                          alt="Uploaded"
                        />
                      </div>
                    ) : (
                      <label
                        className="upload-file h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50 bg-hover-neutral-200 d-flex align-items-center flex-column justify-content-center gap-1"
                        htmlFor="upload-file"
                      >
                        <iconify-icon
                          icon="solar:camera-outline"
                          className="text-xl text-secondary-light"
                        ></iconify-icon>
                        <span className="fw-semibold text-secondary-light">
                          Upload
                        </span>
                        <input
                          id="upload-file"
                          type="file"
                          hidden
                          onChange={handleFileChange}
                        />
                      </label>
                    )}
                    {thumbnailErr && (
                      <span className="error-message">
                        {"Attachment is mandatory"}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-lg-6 pt-3">
                  <button
                    type="submit"
                    className="btn btn-primary-600 mt-3 radius-8"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Sidebar Start */}
    </div>
  );
};

export default AddStaffLayer;
